import { useEffect, useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Banner from "../../assets/img/career_banner.jpg";
import useHandleScroll from "../../hooks/useHandleScroll";
import MapIcon from "../../../src/assets/icons/map-pin.svg";
import Job from "../../assets/icons/briefcase.svg";

const Career = () => {
  const size = useHandleScroll();
  const [career, setCareer] = useState([]);

  useEffect(() => {
    fetch("/careerData.json")
      .then((res) => res.json())
      .then((data) => {
        setCareer(data);
      })
      .catch((err) => console.error("Failed to fetch career data", err));
  }, []);
  document.title = "Career";
  return (
    <div id="career">
      <Navbar sPosition={size}></Navbar>
      <div>
        <div className="relative w-full h-[300px]">
          <img
            src={Banner}
            alt="Career Banner"
            loading="lazy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <h1 className="text-white text-4xl font-semibold underline">
              Join Our Team
            </h1>
          </div>
        </div>
        <div className=" wide:w-[88%] w-[73%] mx-auto">
          <div className="flex text-left bg-white p-8 rounded-lg shadow-lg mt-8">
            <div>
              <h2 className="text-2xl font-bold">Euro Foods Group</h2>
              <div className="flex items-center pb-3">
                <img
                  className=" mobile:h-[12px] mobile:w-[12px] h-[16px] w-[20px] "
                  loading="lazy"
                  src={MapIcon}
                  alt=""
                />
                <p className="pl-3 text-sm mobile:text-xs">Dhaka, Bangladesh</p>
              </div>
              <p>
                Euro Foods Group (EFG), Bangladesh is one of the leading
                companies in the food and fish processing industry in
                Bangladesh, who is manufacturing branded generic products for
                local and overseas markets in Asia, Europe, and the North
                American region. EFG adopted the most recent technology to
                formulate and produce generic formulations ensuring optimum
                quality compared to the international brands.
              </p>
              <h2 className=" font-semibold pt-6">
                Have questions or need assistance?
              </h2>
              <h2 className=" font-semibold pt-4">Contact Us:</h2>
              <p>
                <span className="font-semibold">email:</span>{" "}
                {" Jobs@EuroFoods.co.uk"}
              </p>
            </div>
          </div>
          <div className="flex items-center justify-start mt-8">
            <div className=" border-2 border-gray-300 rounded-lg p-1 bg-[#1B502F] items-center justify-between">
              <img className="" loading="lazy" src={Job} alt="Euro Foods Group Logo" />
            </div>
            <h1 className="text-2xl font-bold text-left">Open Job Positions</h1>
          </div>
          <div className=" text-left py-4  ">
            {career.map((job, index) => (
              <div
                key={index}
                className="border border-gray-200 bg-white rounded-lg p-4 shadow"
              >
                <h2 className="font-bold text-lg mb-2">
                  {" "}
                  <span className="font-semibold">Job Title:</span> {job.post_title}
                </h2>
                <h1 className="text-lg font-semibold">Purpose :-</h1>
                <p className="text-sm text-gray-600 lg:m-4">{job.purpose}</p>
                <h1 className="text-lg font-semibold mt-4">
                  Main duties and responsibilities :-
                </h1>
                <ul className="list-disc pl-5 text-sm text-gray-600 lg:m-4">
                  {job.main_duties_and_responsibilities.map((duty, idx) => (
                    <li key={idx}>{duty}</li>
                  ))}
                </ul>
                <div className=" hidden md:block overflow-x-auto mt-8">
                  <h1 className="font-bold text2xl ">PERSON’S SPECIFICATION</h1>
                  <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700 mt-4">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2">
                          Category
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Essential
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Desirable
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Skills Required */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 font-semibold">
                          Skills Required
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.[
                              "Skills Required"
                            ]?.Essential?.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.[
                              "Skills Required"
                            ]?.Desirable?.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </td>
                      </tr>

                      {/* Attainment */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 font-semibold">
                          Attainment
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.Attainment?.Essential?.map(
                              (item, idx) => (
                                <li key={idx}>{item}</li>
                              )
                            )}
                          </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.Attainment?.Desirable?.map(
                              (item, idx) => (
                                <li key={idx}>{item}</li>
                              )
                            )}
                          </ul>
                        </td>
                      </tr>

                      {/* Knowledge */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 font-semibold">
                          Knowledge
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.Knowledge?.Essential?.map(
                              (item, idx) => (
                                <li key={idx}>{item}</li>
                              )
                            )}
                          </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.Knowledge?.Desirable?.map(
                              (item, idx) => (
                                <li key={idx}>{item}</li>
                              )
                            )}
                          </ul>
                        </td>
                      </tr>

                      {/* Relevant Experience */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 font-semibold">
                          Relevant Experience
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.[
                              "Relevant Experience"
                            ]?.Essential?.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          <ul className="list-disc pl-4">
                            {job.person_specification?.[
                              "Relevant Experience"
                            ]?.Desirable?.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="block md:hidden space-y-6 mt-8">
                  <h1 className="font-bold text2xl">PERSON’S SPECIFICATION</h1>
                  {/* Skills Required */}
                  <div className="border border-gray-300 p-4 rounded-md">
                    <h3 className="font-bold">Skills Required</h3>
                    <p className="font-semibold mt-2">Essential:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.[
                        "Skills Required"
                      ]?.Essential?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                    <p className="font-semibold mt-2">Desirable:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.[
                        "Skills Required"
                      ]?.Desirable?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Attainment */}
                  <div className="border border-gray-300 p-4 rounded-md">
                    <h3 className="font-bold">Attainment</h3>
                    <p className="font-semibold mt-2">Essential:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.Attainment?.Essential?.map(
                        (item, idx) => (
                          <li key={idx}>{item}</li>
                        )
                      )}
                    </ul>
                    <p className="font-semibold mt-2">Desirable:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.Attainment?.Desirable?.map(
                        (item, idx) => (
                          <li key={idx}>{item}</li>
                        )
                      )}
                    </ul>
                  </div>

                  {/* Knowledge */}
                  <div className="border border-gray-300 p-4 rounded-md">
                    <h3 className="font-bold">Knowledge</h3>
                    <p className="font-semibold mt-2">Essential:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.Knowledge?.Essential?.map(
                        (item, idx) => (
                          <li key={idx}>{item}</li>
                        )
                      )}
                    </ul>
                    <p className="font-semibold mt-2">Desirable:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.Knowledge?.Desirable?.map(
                        (item, idx) => (
                          <li key={idx}>{item}</li>
                        )
                      )}
                    </ul>
                  </div>

                  {/* Relevant Experience */}
                  <div className="border border-gray-300 p-4 rounded-md">
                    <h3 className="font-bold">Relevant Experience</h3>
                    <p className="font-semibold mt-2">Essential:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.[
                        "Relevant Experience"
                      ]?.Essential?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                    <p className="font-semibold mt-2">Desirable:</p>
                    <ul className="list-disc pl-5 text-sm">
                      {job.person_specification?.[
                        "Relevant Experience"
                      ]?.Desirable?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="m-4">
                  <h1 className="text-lg font-semibold">
                    Application Process:
                  </h1>

                  <ul className="list-disc pl-6 text-sm text-gray-600 mt-2">
                    {job.application_process.enclosures.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>

                  <p className="text-sm text-gray-600 mt-4">
                    Please send your application to{" "}
                    <span className="font-semibold">
                      {job.application_process.submission_email}
                    </span>
                    .
                  </p>

                  <p className="text-sm text-gray-600 mt-2">
                    <span className="font-semibold">Starting Date:</span>{" "}
                    {job.starting}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <span className="font-semibold">Contract:</span>{" "}
                    {job.contract}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <span className="font-semibold">Salary Range:</span>{" "}
                    {job.salary.range}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <span className="font-semibold">Notes:</span>{" "}
                    {job.salary.notes}
                  </p>

                  <p className="text-sm text-gray-600 mt-4">
                    <span className="font-semibold">Deadline:</span>{" "}
                    {job.deadline}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Career;
